import {connect} from 'react-redux'
import {LoginComponent} from "../component/login";

const mapStateToProps = (state, ownProps) => ({
    mode: state.loginReducer.mode
});

export const Login = connect(
    mapStateToProps, null
)(LoginComponent);